import { render, staticRenderFns } from "./shipment-govt.vue?vue&type=template&id=38fd0fb9&scoped=true&"
import script from "./shipment-govt.vue?vue&type=script&lang=js&"
export * from "./shipment-govt.vue?vue&type=script&lang=js&"
import style0 from "./shipment-govt.vue?vue&type=style&index=0&id=38fd0fb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fd0fb9",
  null
  
)

export default component.exports